<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Código">
            <b-form-input type="text" name="code" v-model="item.code" placeholder="Código"  v-validate="'required'" :state="validateState('code')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('code') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'products.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button class="mr-1" type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Propriedades</strong>
          </div>
          <div class="mb-3" v-for="foreign in foreigns">
            <h6>{{ foreign.label }}</h6>
            <div class="form-inline">
                <b-form-input class="col-sm-2 mr-1" type="text" :name="foreign.key"  v-model="item[foreign.key]" :placeholder="foreign.label"  v-validate="'required'" :state="validateState(foreign.key)"></b-form-input>
                <b-form-input   class="col-md-6 col-sm-5 mr-1" type="text" :name="foreign.field"  :value="item[foreign.key]?item[foreign.field].data.name:''" :placeholder="foreign.label" readonly ></b-form-input>
                <b-button  class="col-md-3 col-sm-4"  variant="success" @click="doShowModal(foreign.field)">selecionar</b-button>
            </div>
          </div>
        </b-card>
      </b-col>
      <!--/.col-->

      <b-modal no-enforce-focus @shown="showModal=true" @hidden="showModal=false" size="lg" ref="prodaggregsModal" id="prodaggregsModal">
        <brands v-if="showModal && modalType=='brand'" height="400" v-on:select-item="selectBrand" />
        <divisions v-if="showModal && modalType=='division'" height="400" v-on:select-item="selectDivision" />
        <categories v-if="showModal && modalType=='category'" height="400" v-on:select-item="selectCategory" />
        <shoppinggroups v-if="showModal && modalType=='shoppinggroup'" height="400" v-on:select-item="selectShoppingGroup" />
        <subsectors v-if="showModal && modalType=='subsector'" height="400" v-on:select-item="selectSubsector" />
        <top10 v-if="showModal && modalType=='top10'" height="400" v-on:select-item="selectTop10" />
        <varieties v-if="showModal && modalType=='variety'" height="400" v-on:select-item="selectVariety" />
      </b-modal>
    </div>
  </form>

</div>
</template>

<script>
import Brands from '../brands/modal.vue'
import Divisions from '../divisions/modal.vue'
import Categories from '../categories/modal.vue'
import Shoppinggroups from '../shoppinggroups/modal.vue'
import Subsectors from '../subsectors/modal.vue'
import Top10 from '../top10/modal.vue'
import Varieties from '../varieties/modal.vue'

export default {
  name: 'ProductsEdit',
  props: ['id'],
  components: { Brands, Divisions, Categories, Shoppinggroups, Subsectors, Top10, Varieties },
  data() {
    return {
      showModal: false,
      modalType: null,
      showPassword: false,
      item: {
        name: '',
        code: '',
        quantity: 1,
        niv:0,
        to:0
      },
      foreigns: [{
        name: 'brand',
        label: 'Marca',
        key: 'brand_id',
        field: 'brand'
      }, {
        name: 'division',
        label: 'Divisão',
        key: 'division_id',
        field: 'division'
      }, {
        name: 'category',
        label: 'Categoria',
        key: 'product_category_id',
        field: 'category'
      }, {
        name: 'shoppinggroup',
        label: 'Shopping Group',
        key: 'shopping_group_id',
        field: 'shoppinggroup'
      }, {
        name: 'subsector',
        label: 'Sub-sector',
        key: 'subsector_id',
        field: 'subsector'
      }, {
        name: 'variety',
        label: 'Variedade',
        key: 'variety_id',
        field: 'variety'
      }, {
        name: 'top10',
        label: 'Top10',
        key: 'top10_id',
        field: 'top10'
      }]
    }
  },
  methods: {
    selectBrand(e) {
      this.item.brand_id = e.item.id
      this.item.brand.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectDivision(e) {
      this.item.division_id = e.item.id
      this.item.division.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectCategory(e) {
      this.item.product_category_id = e.item.id
      this.item.category.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectShoppingGroup(e) {
      this.item.shopping_group_id = e.item.id
      this.item.shoppinggroup.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectSubsector(e) {
      this.item.subsector_id = e.item.id
      this.item.subsector.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectVariety(e) {
      this.item.variety_id = e.item.id
      this.item.variety.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    selectTop10(e) {
      this.item.division_id = e.item.id
      this.item.top10.data = e.item
      this.$refs.prodaggregsModal.hide()
    },
    doShowModal(type) {
      this.modalType = type
      this.$refs.prodaggregsModal.show()
    },
    hideModal() {
      this.$refs.prodaggregsModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('prodaggregs' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'prodaggregs.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('prodaggregs', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'prodaggregs.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('prodaggregs' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'prodaggregs.index'
          })
        })
    }
  }
}
</script>
